import { IconClock, IconMapPin } from "@tabler/icons-react";
import { formatTo12Hour } from "utils";
import AppContext from "Context/appContext";
import "containers/BookingList/index.css";
import { useContext, useEffect, useState } from "react";
// import { ClipLoader } from "react-spinners";
import BookingDetails from "./BookingDetails";
import Input from "components/Input";
// import UrlServices from "../../services/Url";
const { formatInTimeZone } = require('date-fns-tz');

const Bookinglist = () => {
  // const [bookingList, setBookingList] = useState([]);
  // const [filteredBookingList, setFilteredBookingList] = useState([]);
  const [width, setWidth] = useState(300);
  const [search, setSearch] = useState("");
  const {
    setSelectedStoreDetails,
    selectedStoreDetails,
    progressState,
    setProgressState,
    toggle,
    setToggle,
    selectedBookingPage,
    setSelectedBookingPage,
    setDefaultStore,
    isWebView,
    userSettings,
    buttonClicked,
    loading,
    countryDetails,
    bookingList,
    filteredBookingList,
    setFilteredBookingList
  } = useContext(AppContext);

  const key = "AIzaSyBlqrSdiC-YtE8DGNRJXRGXyoFQiHGsER4";

  // set width for iframe google map
  const updateWidth = () => {
    // Set the width to 200 for screens with a width less than 600px
    if (window.innerWidth <= 768) {
      setWidth("100%");
    } else {
      setWidth(300); // Set the default width for larger screens
    }
  };

  // Function to open Google Maps in a new tab on mobile
  const handleViewMap = (el) => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      el.address
    )}`;
    window.open(mapsUrl, "_blank"); // Open Google Maps in a new tab
  };

  useEffect(() => {
    // Initial width update
    updateWidth();
    window.addEventListener("resize", updateWidth);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  const fetchData = async () => {
    if (!userSettings?.isQuoteLocationsEnabled && buttonClicked === "quote") {
      setProgressState(6);
      return;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Search handler to filter booking list based on user input
  const handleChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    const filteredList = bookingList.filter(
      (b) =>
        b.name.toLowerCase().includes(query) ||
        b.address.toLowerCase().includes(query) ||
        b.city.toLowerCase().includes(query) ||
        b.state.toLowerCase().includes(query) ||
        b.postcode.toLowerCase().includes(query) ||
        b.country.toLowerCase().includes(query)
    );
    setFilteredBookingList(filteredList);
  };

  const toggleBookingDetail = (bookingDetail) => {
    setProgressState(6);
    setSelectedBookingPage(bookingDetail);
    setToggle(true);
    setDefaultStore(true);
    setSelectedStoreDetails({
      store_id: bookingDetail.store_id,
      store_name: bookingDetail.name,
    });
  };

  // const isStoreOpen = (startTime, endTime) => {
  //   const now = new Date();
  //   const start = new Date().setHours(...startTime?.split(":"));
  //   const end = new Date().setHours(...endTime?.split(":"));

  //   return start < end
  //     ? now >= start && now <= end
  //     : !(now < end || now > start);
  // };

const isStoreOpen = (startTime, endTime) => {
  const now = new Date();
  const nowInZone = formatInTimeZone(now, countryDetails.time_zone, 'HH:mm');

  const [nowHours, nowMinutes] = nowInZone.split(':').map(Number);
  const [startHours, startMinutes] = startTime.split(':').map(Number);
  const [endHours, endMinutes] = endTime.split(':').map(Number);

  const nowMinutesTotal = nowHours * 60 + nowMinutes;
  const startMinutesTotal = startHours * 60 + startMinutes;
  const endMinutesTotal = endHours * 60 + endMinutes;

  // Normal case: store opens and closes on the same day
  if (startMinutesTotal < endMinutesTotal) {
    return nowMinutesTotal >= startMinutesTotal && nowMinutesTotal <= endMinutesTotal;
  } else {
    // Overnight case: store opens late and closes after midnight
    return nowMinutesTotal >= startMinutesTotal || nowMinutesTotal <= endMinutesTotal;
  }
};

  // if (storesFetchLoader) { 
  //   return (
  //     <div className="rd-quote-flex rd-quote-h-screen rd-quote-items-center rd-quote-justify-center rd-quote-mx-auto">
  //       <ClipLoader color="dark-green" loading={storesFetchLoader} size={70} />
  //     </div>
  //   );
  // }

  return (
    <div className="quote-booking-main scrollbar-colorr md:rd-quote-pr-[16px] quote-colum xs:rd-quote-w-full md:rd-quote-w-[75%]">
      {progressState === 5 && bookingList.length > 1 && (
        <Input
          placeholder={`Search Store`}
          isShowIcon={true}
          value={search}
          handleChange={handleChange}
          className="input-field-search"
        />
      )}
      {!toggle && (
        <div
          className={`quote-booking-scroller quote-scroll-booking-list scrollbar-colorr quote-scroller-hide lg:rd-quote-h-[510px] lg:rd-quote-max-h-[620px] rd-quote-gap-y-4 rd-quote-flex rd-quote-flex-col xs:rd-quote-pr-[5px] lg:rd-quote-pr-3`}
        >
          {filteredBookingList.length > 0 ? (
            filteredBookingList.map((b, index) => (
              <div
                onClick={() => toggleBookingDetail(b)}
                key={b.id}
                style={{
                  '--border-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                }}
                className={`quote-booking-card rd-quote-border rd-quote-rounded-md rd-quote-border-gray-300 rd-quote-shadow
            ${
              selectedStoreDetails?.store_id === b?.store_id ||
              (!selectedStoreDetails?.store_id && index === 0)
                ? "rd-quote-border rd-quote-border-[var(--border-bg-color)]"
                : ""
            }
          `}
              >
                <div className="quote-row-justify quote-direction-column">
                  <div className="quote-colum">
                    <div className="rd-quote-flex rd-quote-justify-between rd-quote-items-center rd-quote-mb-2">
                      <span className="quote-text2">{b.alt_name ? b.alt_name : b.name}</span>
                      {/* For Mobile only */}
                      {!isWebView && (
                        <span
                          style={{
                            '--button-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                          }}
                          className="rd-quote-cursor-pointer rd-quote-text-[var(--button-bg-color)] rd-quote-min-w-[105px] rd-quote-text-center"
                          onClick={(event) => {
                            event.stopPropagation(); // Prevents parent click
                            handleViewMap(b);
                          }}
                        >
                          View on map
                        </span>
                      )}
                    </div>
                    <div className="quote-row rd-quote-mb-2">
                      <IconMapPin className="rd-quote-w-5 rd-quote-h-5 rd-quote-text-gray-500" />
                      <div className="quote-text1 rd-quote-ml-2">
                        {b.address !== "" ? b.address.concat(", ") : ""}
                        {b.city !== "" ? b.city.concat(" ") : ""}
                        {b.state !== "" ? b.state.concat(" ") : ""}
                        {b.postcode !== ""
                          ? b.country !== ""
                            ? b.postcode.concat(", ")
                            : b.postcode
                          : ""}
                        {b.country}
                      </div>
                    </div>
                    <div className="quote-row">
                      <IconClock className="rd-quote-w-5 rd-quote-h-5 rd-quote-text-gray-500" />
                      <span
                        className={`${
                          isStoreOpen(b.start_time, b.end_time)
                            ? "rd-quote-text-green-600"
                            : "rd-quote-text-rose-600"
                        } rd-quote-text-sm rd-quote-font-normal rd-quote-font-['SF Pro Text'] rd-quote-leading-5 rd-quote-mx-2`}
                      >
                        {isStoreOpen(b.start_time, b.end_time)
                          ? "Open"
                          : "Closed"}
                      </span>
                      <span className="quote-text1">-</span>
                      <div className="quote-text1 rd-quote-ml-2">
                        Closed at {b?.end_time && formatTo12Hour(b.end_time)}
                      </div>
                    </div>
                  </div>
                  {/* for tablet and laptop screen only */}
                  {isWebView && (
                    <div className="quote-margin-top">
                      <iframe
                        title="google map"
                        src={`https://www.google.com/maps/embed/v1/place?key=${key}&q="+ ${encodeURIComponent(
                          b.address
                        )}"`}
                        width={width}
                        height="140"
                        allowFullScreen=""
                        loading="lazy"
                      ></iframe>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="rd-quote-w-full rd-quote-flex rd-quote-justify-center rd-quote-items-center xs:rd-quote-pt-5 md:rd-quote-pt-0 lg:rd-quote-h-[55vh]">
              <div className="rd-quote-my-auto rd-quote-text-gray-600 rd-quote-text-base rd-quote-font-semibold">
                No Results Found
              </div>
            </div>
          )}
        </div>
      )}

      {toggle && selectedBookingPage && !loading && (
        <BookingDetails
          bookingDetail={selectedBookingPage}
          key={selectedBookingPage?.store_id}
          getStoreTime={isStoreOpen}
        />
      )}
    </div>
  );
};

export default Bookinglist;
